import { programLabels } from '@/config';
import { getManufacturerByProgram } from '@/libs/util';

const Yimmugo = ({
  name,
  themeColor,
  supportPhone,
}: {
  name: string;
  themeColor: string;
  supportPhone: string;
}) => {
  return (
    <>
      <div className="mx-auto py-10">
        <div className="text-xl md:text-3xl font-bold text-[#000000]">
          <span style={{ color: themeColor }}>
            {programLabels[name as keyof typeof programLabels].name}
          </span>
          &nbsp; SUPPORT FOR PATIENTS
        </div>

        <div className="mt-10 text-2xl font-bold">COPAY ASSISTANCE</div>

        <p className="my-2">
          Eligible patients can receive up to $8,000 per calendar year to cover the deductible,
          copay, and/or coinsurance for YIMMUGO.
        </p>

        <ul className="my-2 list-disc ml-10">
          <li>
            Please ask your provider to bill Medmonk for your copay assistance at the time of
            dispensing. This streamlined approach facilitates the process, ensuring prompt access to
            the copay assistance you need.
          </li>
          <li>
            YIMMUGO copay assistance can typically be used regardless of whether your healthcare
            provider is billing through your major medical plan or your pharmacy benefits.
          </li>
        </ul>

        <div className="mt-10 font-bold">ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE</div>

        <ul className="my-2 list-disc ml-10">
          <li>Patients must be commercially insured.</li>
          <li>Patients must express a financial need.</li>
          <li>
            Patients' health plan permits members to participate in copay assistance programs.
          </li>
          <li>Patients must be prescribed YIMMUGO by a licensed prescriber.</li>
        </ul>

        <div className="my-2 font-bold">RESTRICTIONS</div>

        <ul className="my-2 list-disc ml-10">
          <li>
            Not valid for prescriptions eligible for reimbursement by any federal or state
            healthcare programs, such as Medicare, Medicaid, Medigap, Veterans Affairs, Department
            of Defense, Tricare, or any other federal or state-funded programs.
          </li>
          <li>See full Terms and Conditions below.</li>
        </ul>

        <div className="mt-10 text-2xl font-bold">REIMBURSEMENT SUPPORT</div>

        <p className="my-2">
          For inquiries or assistance with reimbursment, including benefits verification and/or
          authorization, please contact our Support Team at{' '}
          <a
            className="text-blue-500 hover:text-blue-600 hover:underline"
            href={`tel:${supportPhone}`}
          >
            {supportPhone}
          </a>
          . We&apos;re here to provide support where needed.
        </p>

        <div className="mt-6">
          This program is subject to change or discontinuation by&nbsp;
          <b>{getManufacturerByProgram(name)}</b>
          &nbsp;at any time, for any reason, and with or without prior notice. This portal is
          administered by&nbsp;
          <a target="_blank" href="https://medmonk.com/" className="text-blue-500 hover:underline">
            Medmonk
          </a>
          &nbsp;for the {programLabels[name as keyof typeof programLabels].label} Program.
        </div>

        <div className="mt-10 text-2xl font-bold">TERMS AND CONDITIONS</div>

        <p className="my-2">
          Kedrion Biopharma’s YIMMUGO Copay Assistance Program (the “Program”) provides financial
          support for patients who meet all the eligibility criteria.  Participation in the Program
          and provision of financial support is subject to these Program Terms and Conditions,
          including the $8,000 yearly maximum (“Yearly Program Maximum”).  By enrolling in the
          Program, you agree that the Program is intended solely for the benefit of you, the
          patient, not health plans and/or their partners, and that you will comply with all
          applicable requirements of your health plan.  The Program is not valid for patients that
          pay cash, are currently in a coverage gap, insurance pays the entire cost of their
          prescription, or are a beneficiary of, or any part of their prescription is covered by:
          any federal, state, or government-funded health program (Medicare, Medicare Advantage,
          Medicare Part D, Medicaid, Medigap, TRICARE®, Veterans Affairs (VA), the Department of
          Defense (DoD), or the Government Health Insurance Plan available in Puerto Rico).  No
          claim for reimbursement of the out-of-pocket expense amount covered by the Program shall
          be submitted to any public or private third-party payer, including flexible spending
          accounts (FSA) or healthcare savings accounts (HSA).  If you are enrolled in a co-pay
          maximizer program, your Yearly Program Maximum may vary over time to ensure the program
          funds are used for your benefit.  Kedrion reserves the right to reduce or eliminate the
          copay assistance available to patients it becomes aware that they are enrolled in an
          insurance plan that utilizes a co-pay maximizer program.  If you learn your health plan
          has implemented a co-pay maximizer program, you agree to notify the Program immediately. 
          The Program only applies in the United States and its territories, and does not apply
          where prohibited by law, taxed, or restricted. Coverage of certain administration charges
          will not apply for patients residing in states where it is prohibited by law.  This does
          not constitute health insurance.  Void where use is prohibited by your insurance
          provider.  You agree to notify the Program immediately if your insurance situation
          changes.  This Program is not transferable and is limited to one per patient and may not
          be combined with any other coupon, discount, prescription savings card, rebate, free
          trial, patient assistance, alternative funding program, co-pay accumulator, or other
          offer, including those from third parties and companies that help insurers or health plans
          manage costs. Not valid if reproduced.  Any individual or entity who enrolls or assists in
          the enrollment of a patient in the Program represents that the patient meets the
          eligibility criteria and other requirements described herein. Additional terms and
          conditions may apply.  Data related to your redemption of the Program may be collected,
          analyzed, and shared with Kedrion Biopharma for market research and other purposes related
          to assessing its programs.  Data shared with Kedrion Biopharma will be aggregated and
          de-identified.
        </p>
      </div>
    </>
  );
};

export default Yimmugo;
